const getTopBarHeight = (state: AnyFixMe) => state.config.topBarHeight;

export default { getTopBarHeight };
